import React from 'react';
import { getContext } from 'common';
import Styled from './styles';

export interface SelectItemSubTextProps extends React.ComponentPropsWithRef<'div'> {
  /** Place content here. */
  children: React.ReactNode;
}

/** Place second line of content here. */
const SelectItemSubText = React.forwardRef<HTMLElement, SelectItemSubTextProps>((props: SelectItemSubTextProps, ref) =>
  getContext(({ RTL, theme }) =>
    <Styled.SelectItemSubText ref={ref} RTL={RTL} $theme={theme && theme.LIST && theme.LIST.VERTICAL} {...props} />));

SelectItemSubText.displayName = 'SelectItemSubText';

/* Exports */
export { SelectItemSubText as default };
